import { render } from "./TeamCards.vue?vue&type=template&id=10d6c4fd&scoped=true"
import script from "./TeamCards.vue?vue&type=script&lang=js"
export * from "./TeamCards.vue?vue&type=script&lang=js"

import "./TeamCards.vue?vue&type=style&index=0&id=10d6c4fd&lang=scss&scoped=true"

import exportComponent from "E:\\LEIGH_STORE\\PROJECTS\\2-PROJECTS\\6-PIYOOK\\ICS-Digital\\1-Dominic-Projects\\7-football-earnings\\5-website\\footy-earnings\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d6c4fd"]])

export default __exports__